export const RTR_PARTNER = 'rtr'
export const TRR_PARTNER = 'trr'
export const PETCO_PARTNER = 'petco'
export const REVOLVE_PARTNER = 'revolve'
export const HIBBETT_PARTNER = 'hibbett'
export const NORDSTROM_PARTNER = 'nordstrom'

export const DISABLED_PARTNERS = [TRR_PARTNER]
